export const EnumAPIKey = {
  API_BASE: 'API_BASE',
  API_MAIN: 'API_MAIN',
  API_INTG: 'API_INTG',
}

export const apiConfig: any = {
  [EnumAPIKey.API_BASE]: process.env.NEXT_PUBLIC_API_URL,
  [EnumAPIKey.API_INTG]: process.env.NEXT_PUBLIC_API_INTEGRATION_URL,
  [EnumAPIKey.API_MAIN]: process.env.NEXT_PUBLIC_API_URL_MAIN
};

export const EnumMethod = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  DEL: 'del'
}

export const pathNotAllowedCrawl = ["/checkout", "/order-status", "/payment", "/cart"]